import {fetchCognitoConfig} from "../api/config.service";

const getUser = () => {
    const user = localStorage.getItem('user');

    if (user) {
        return JSON.parse(user);
    }

    return null;
}
export const cognitoLogout = async () => {
    // Always clear local app state first
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("USER");
    localStorage.removeItem("user");
    localStorage.removeItem("REDIRECT_URL");

    try {
        const config = await fetchCognitoConfig();

        // Use origin (includes protocol + host + port)
        const appLoginUrl = `${window.location.origin}`;

        // Normalize domain (avoid double slashes)
        const domain = String(config.domain || "").replace(/\/+$/, "");
        if (!domain || !config.clientId) {
            throw new Error("Missing required Cognito configuration (domain/clientId).");
        }

        const logoutUrl =
            `${domain}/logout?` +
            `client_id=${encodeURIComponent(config.clientId)}` +
            `&logout_uri=${encodeURIComponent(appLoginUrl)}`;
        localStorage.clear();

        window.location.assign(logoutUrl);
    } catch (err) {
        console.warn("Cognito logout skipped (no/invalid config). Redirecting to /login.", err);
        localStorage.clear();
        window.location.assign("/");
    }
};
export const getUserId = () => {
    return getUser()?.id;
}

export const isAdmin = () => {
    const roles = getUser()?.roles;
    if (!roles || !Array.isArray(roles) || roles.length === 0) {
        return false;
    }
    return roles[0] !== 'ROLE_USER';
}


export const getRole = () => {
    return getUser()?.roles
}

export const channelRequired = () => (process.env.REACT_APP_CHANNEL_REQUIRED || '') == 'true';
export const audioPlayerVisible = () => (process.env.REACT_APP_AUDIO_PLAYER || '') == 'true';